import { createContext } from "react";

type LightBoxApi = {
  // eslint-disable-next-line no-unused-vars
  addImage(src: string, alt: string): void;
  // eslint-disable-next-line no-unused-vars
  removeImage(src: string): void;
  // eslint-disable-next-line no-unused-vars
  open(src: string): void;
};

export const LightBoxApiContext = createContext<LightBoxApi>({
  addImage: () => undefined,
  removeImage: () => undefined,
  open: () => undefined,
});
